"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.useProdToken = useProdToken;
exports.useDevToken = useDevToken;
exports.isConfigured = isConfigured;
exports.configure = configure;
exports.TRAAC_CONFIG = void 0;

var _defineProperty = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var useProd = false;
var piAdapter = {
  type: 'BlueHttp',
  config: {
    url: 'https://collector-product-insight.thomsonreuters.com/v1/data',
    flush_period: 60000,
    headers: {}
  }
};
(0, _defineProperty.default)(piAdapter.config.headers, 'X-PRODUCT-INSIGHTS-TOKEN', {
  enumerable: true,
  get: function get() {
    return useProd ? 'vIVU3MIibpvd7DRjQGpdhSrRypYC66K1' : 'd6PkzZ2pIRi3dANyr7IWORQcEww1qnSW';
  }
});
var TRAAC_CONFIG = {
  version: '0.8.8',
  teq: [],
  adapters: []
};
exports.TRAAC_CONFIG = TRAAC_CONFIG;
window.TRAAC_CONFIG = TRAAC_CONFIG;

function useProdToken() {
  useProd = true;
}

function useDevToken() {
  useProd = false;
}

function isConfigured() {
  return TRAAC_CONFIG.adapters[0] === piAdapter;
}

function configure() {
  if (isConfigured()) {
    console.warn('TRAAC already configured!');
    return;
  }

  if (window.TRAAC.registerProvider) {
    TRAAC_CONFIG.adapters.push(piAdapter);
    window.TRAAC.registerProvider(piAdapter.type, piAdapter.config);
  } else {
    throw new Error('TRAAC is not loaded yet');
  }
}
